<template>
    <div class="card cancelbid ice-wrap" >
        <div class="card-body">
            <div class="modal-header">
                <h5 class="card-title">Bid Info</h5>
                <p>{{bid.cusipDescription}}</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                    <i class="fas fa-times-circle"></i>
                </button>
            </div>
            <div class="card-text" v-bind:style=" bid ? 'display:block' : 'display: none;'">
                <ul>
                    <li>Bid Status :<span> {{getBidStatus(bid.status)}}</span></li>
                    <li>Bid Cancelled Time :<span>{{bid.cancelledAt ? moment_timezone(bid.cancelledAt).tz('America/New_York').format("MM/DD/YYYY HH:mm:ss") : 'N/A'}} {{bid.cancelledAt ? 'EST' : ''}}</span></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'cancelbidinfo',
    props: ['bid'],
    methods: {
        getBidStatus(status){
            var returnStatus;
            switch (status) {
                case 'NEW':
                    returnStatus = "Live"
                    break;
                case 'CANCEL_TRADER':
                    returnStatus = "Cancelled By Trader"
                    break;
                case 'CANCEL_ADMIN':
                    returnStatus = "Cancelled By Admin"
                    break;
                case 'CANCEL_YIELD_UPDATE':
                    returnStatus = "Cancelled On Yield Update"
                    break; 
                case 'CANCEL_CURVE':
                    returnStatus = "Cancelled On Curve Change"
                    break;
                case 'CANCEL_MIN_QUANTITY':
                    returnStatus = "Cancelled On Minimum Quantity Success"
                    break; 
                    default:
                    returnStatus = "N/A";                          

            }
            return returnStatus;
        }
    }
};
</script>